<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="flex items-start">
    <Sidebar :navMenuItems="navMenuItems" @toggleSidebar="isExpanded = $event" class="flex-shrink-0"></Sidebar>
    <div class="py-[32px] lg:px-[24px] px-[16px] h-[100vh] overflow-auto flex-grow sm:mb-0 mb-[86px]" :style="`${ isExpanded ? 'width: calc(100% - 270px)' : 'width: calc(100% - 82px)'}`" id="scrollContainer">
      <transition :name="routerTransition">
        <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
          <div v-if="routeTitle" class="content-area__heading mr-4" :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
            <h2 class="mb-1">{{ $t(routeTitle) }}</h2>
          </div>
          <!-- BREADCRUMB -->
          <vx-breadcrumb class="md:block hidden" :i18nData="i18nData" :store="$store" v-if="$route.meta.breadcrumb" :route="$route" :lang="$i18n.locale" :isRTL="$vs.rtl" />
        </div>
      </transition>

      <transition :name="routerTransition" mode="out-in">
        <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
      </transition>
    </div>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import i18nData from '../../i18n/i18nData.js'
import Sidebar from '../components/Sidebar.vue'
import { transporter } from '../admin/newNavMenuItems.js'

export default {
  components: {
    Sidebar
  },
  data () {
    return {
      i18nData,
      navMenuItems      : [],
      transporter,
      isExpanded         : true,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    }
  },
  methods: {
    changeRouteTitle (title) {
      this.routeTitle = title
    }
  },
  created () {
    const userRole = ['transporter']
    if (userRole.includes(this.$store.state.AppActiveUser.userRole)) {
      this.navMenuItems = []
      switch (this.$store.state.AppActiveUser.userRole) {
      case 'transporter':
        this.navMenuItems = this.transporter
        break
      }
    }
    if (this.$cookies.get('language') === 'en') {
      this.$i18n.locale = 'en'
      this.$vs.rtl = false
    } else {
      this.$i18n.locale = 'ar'
      this.$vs.rtl = true
    }
  }
}
</script>

<style>
#shipblu-chat-launcher,
#shipblu-chat-frame,
#fc_frame {
  display: none;
}
</style>